import { render, staticRenderFns } from "./EquipoTrabajo.vue?vue&type=template&id=5549fb89&"
import script from "./EquipoTrabajo.vue?vue&type=script&lang=js&"
export * from "./EquipoTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports